import cartItem from '../ecommerce/cartItem';

const cart = () => {
  cartItem.initialize();
};

export default cart;
